module.exports = __webpack_public_path__ + "img/logo9.e6bac90e.png";